export default "__VITE_ASSET__D80ax6T4__"